import type { NotifyType } from '@/api/user'

export interface UserSettingParsed {
  notify_type?: NotifyType
  quota_warning_threshold?: number
  webhook_url?: string
  webhook_secret?: string
  notification_email?: string
  bark_url?: string
  gotify_url?: string
  gotify_token?: string
  gotify_priority?: number
  upstream_model_update_notify_enabled?: boolean
  accept_unset_model_ratio_model?: boolean
  record_ip_log?: boolean
  sidebar_modules?: string
  billing_preference?: string
  language?: string
}

export const DEFAULT_USER_SETTING: UserSettingParsed = {
  notify_type: 'email',
  quota_warning_threshold: 500000,
  gotify_priority: 5,
  accept_unset_model_ratio_model: false,
  record_ip_log: false,
  upstream_model_update_notify_enabled: false,
}

export function parseUserSetting(raw?: string): UserSettingParsed {
  if (!raw) return { ...DEFAULT_USER_SETTING }
  try {
    const parsed = JSON.parse(raw) as Record<string, unknown>
    if (!parsed || typeof parsed !== 'object') return { ...DEFAULT_USER_SETTING }
    return {
      ...DEFAULT_USER_SETTING,
      notify_type: (parsed.notify_type as NotifyType) || DEFAULT_USER_SETTING.notify_type,
      quota_warning_threshold:
        typeof parsed.quota_warning_threshold === 'number'
          ? parsed.quota_warning_threshold
          : DEFAULT_USER_SETTING.quota_warning_threshold,
      webhook_url: String(parsed.webhook_url || ''),
      webhook_secret: String(parsed.webhook_secret || ''),
      notification_email: String(parsed.notification_email || ''),
      bark_url: String(parsed.bark_url || ''),
      gotify_url: String(parsed.gotify_url || ''),
      gotify_token: String(parsed.gotify_token || ''),
      gotify_priority:
        typeof parsed.gotify_priority === 'number'
          ? parsed.gotify_priority
          : DEFAULT_USER_SETTING.gotify_priority,
      upstream_model_update_notify_enabled: !!parsed.upstream_model_update_notify_enabled,
      accept_unset_model_ratio_model: !!parsed.accept_unset_model_ratio_model,
      record_ip_log: !!parsed.record_ip_log,
      sidebar_modules: parsed.sidebar_modules ? String(parsed.sidebar_modules) : undefined,
      billing_preference: parsed.billing_preference ? String(parsed.billing_preference) : undefined,
      language: parsed.language ? String(parsed.language) : undefined,
    }
  } catch {
    return { ...DEFAULT_USER_SETTING }
  }
}
